import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { ModalComponent } from '../../shared/components/modal/modal.component';
import { Distributor } from '../../shared/models/Distributor';
import { FilterObject } from '../../shared/models/FilterObject';
import { OrderDetail } from '../../shared/models/OrderDetail';
import { OrderHistory } from '../../shared/models/OrderHistory';
import { PagingResults } from '../../shared/models/PagingResult';
import { User } from '../../shared/models/User';
import { GlobalService } from '../../shared/services/global';
import { HttpService } from '../../shared/services/HttpService';

@Component({
  selector: 'app-dashboard-orderstatus',
  templateUrl: './orderstatus.component.html',
  styleUrls: ['./orderstatus.component.css']
})
export class OrderstatusComponent implements OnInit, OnDestroy {
  readonly Page: string = "OrderStatus";
  OrderList: OrderHistory[];
  DistList: Distributor[];
  DistSubscription: Subscription;
  CurrentDist: string;
  CurUser: User;
  HideDist: boolean;
  HideComponent: boolean;
  OrderSortValue: string;
  FilterList: FilterObject[];
  CustFilter: FilterObject;
  PageIndex: number;
  PageSize: number;
  CurrentOpenDialog: MatDialogRef<ModalComponent, any>;
  readonly PageSizeOptions: number[] = [5, 10, 20, 50];
  hideLoadingModal: boolean;
  constructor(private http: HttpService, private global: GlobalService, private router: Router, public matDialog: MatDialog) { }

  ngOnInit(): void {
    this.hideLoadingModal = true;
    this.CurUser = new User();
    this.OrderSortValue = "orderdate";
    this.PageIndex = 0;
    this.PageSize = 10;
    this.global.getCurrentDist().then(dist => {
      this.global.getCurrentUser().then(x => {
        this.CurUser = x;

        if (this.CurUser != null) {
          if (!this.CurUser.HasPagePermission("orderstatus")) {
            this.HideComponent = true;
          }
          else {
            if (this.CurUser.IsTolomaticUser) {
              this.HideDist = false;
            }
            else {
              this.HideDist = true;
            }



            this.CustFilter = new FilterObject();
            this.CustFilter.Key = "customer";
            this.global.GetDistList().then(x => {
              this.DistList = x;
              if (dist) {
                if (!this.CurUser.IsTolomaticUser && this.CurUser.DistributorId == dist.CompanyId) {
                  this.CurrentDist = dist.CompanyId;
                }
                else if (this.CurUser.IsTolomaticUser) {
                  this.CurrentDist = dist.CompanyId;
                }
                else {
                  this.CurrentDist = this.CurUser.DistributorId;
                }
              }
              else {
                if (!this.CurUser.IsTolomaticUser && this.CurUser.DistributorId != "") {
                  this.CurrentDist = this.CurUser.DistributorId;
                } else {
                  this.CurrentDist = this.DistList[0].CompanyId;
                }
              }

              this.CustFilter.Value = this.CurrentDist;
              this.FilterList = [];
              this.FilterList.push(this.CustFilter);
              this.LoadOrders();
            });
            
            var initialLoad = true;
            this.DistSubscription = this.global.CurrentDist.subscribe(dist => {
              debugger;
              if (dist && !initialLoad) {
                this.CurrentDist = dist.CompanyId;
                this.CustFilter.Value = this.CurrentDist;
                this.LoadOrders();

              }
              initialLoad = false;
            });
          }
        }
      });
    });
  }

  ngOnDestroy() {
    if (this.DistSubscription) {
      this.DistSubscription.unsubscribe();
    }
  }

  LoadOrders() {
    this.hideLoadingModal = false;
    this.http.GetOrders(this.FilterList, this.CurUser.UserId.toString(), this.PageIndex, this.PageSize, this.OrderSortValue).then(x => {
      if (x.StatusCode == "200") {
        var results = <PagingResults>x.Content;
        this.OrderList = results.Items;
        this.OrderList.forEach(x => {
          x.ShortShipTo = x.ShipToName;
          if (x.ShortShipTo.length > 20) {
            x.ShortShipTo = x.ShortShipTo.substring(0, 20) + "...";
          }
        });
      }
      this.hideLoadingModal = true;
    });
  }


  LoadDetails(custOrder: OrderHistory) {    
    if (!custOrder.OrderLines) {
      this.hideLoadingModal = false;
      this.http.GetOrderDetails(custOrder.OrderNumber, this.CurUser.UserId.toString()).then(x => {
        if (x.StatusCode == "200") {
          custOrder.OrderLines = x.Content;
          custOrder.OrderLines.forEach(x => {
            x.ShortDesc = x.Description;
            if (x.ShortDesc.length > 20) {
              x.ShortDesc = x.ShortDesc.substring(0, 17) + "...";
            }
          });
        }
        this.hideLoadingModal = true;
      });
    }     
  }


  Dist_Change(event: any) {
    //this.CurrentDist = event.value;
    //this.CustFilter.Value = this.CurrentDist;
    var newDist = this.DistList.filter(x => x.CompanyId == event.value)[0];
    this.global.setCurrentDist(newDist);
    //this.LoadOrders();
  }

  OrderSort_Change(event: any) {
    this.OrderSortValue = event.value;
    this.LoadOrders();
  }

  FollowOrder(follow: boolean, orderDetailRowPointer: string) {
    this.http.PostUserActivity(this.CurUser.UserId.toString(), "Order Status", "Follow Order", orderDetailRowPointer, this.CurUser.IsTolomaticUser ? this.CurrentDist : this.CurUser.DistributorId);
    this.http.FollowOrderDetail(follow, orderDetailRowPointer, this.CurUser.UserId.toString());
  }


  ViewDetails(order: OrderHistory, detail: OrderDetail) {
    var dialogConfig = this.GetDialogConfig("NewForce");

    var orderObject = { type: "OrderDetail", order: order, detail: detail };
    dialogConfig.data = orderObject;

    this.CurrentOpenDialog = this.matDialog.open<ModalComponent>(ModalComponent, dialogConfig);

    this.CurrentOpenDialog.componentInstance.CloseEventEmitter.addListener("closeEvent", (event) => {
      this.CurrentOpenDialog.close();
    });
  }

  ViewFullDetails() {
    //[routerLink] = "['/orderstatus']"

    this.router.navigateByUrl('/orderstatus', { state: { sortValue: this.OrderSortValue, distributor: this.CurrentDist } });
  }


  GetDialogConfig(name: string): MatDialogConfig {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.id = name;
    dialogConfig.height = "80%";
    dialogConfig.width = "80%";

    return dialogConfig;
  }
}
